var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"w-full h-full fixed inset-0 flex flex-col items-center justify-center bg-gray-900 bg-opacity-75 fullscreen"},[_c('i',{staticClass:"fa-solid fa-spinner fa-6x animate-spin loading-effect spinnerClass"}),_c('p',{staticClass:"text-xl mt-4 textClass"},[_vm._v(_vm._s(_vm.text))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }